/* eslint-disable import/prefer-default-export */
import { Get } from '../requestBuilder/buildFetchRequest';
import ModelMetaData from './ModelMetadata';

export const getModelMetadata = (key: 'timecard' | string): Promise<ModelMetaData> => (
  Get(`/api/modelMetaData/${key}`)
    .Execute()
);
